var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSarForDarkTheme(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "547d19fc-9aa2-4c06-bd99-d5670708d7f8"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "afcf4db7-f1ea-4bc2-9069-314d4ca2cdee"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 330.62 511.39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-892.68, -1139.58)",
    d: "M 699.62 1113.02 L 699.62 1113.02 C 679.5600000000001 1157.5 666.3 1205.77 661.22 1256.3899999999999 L 1085.73 1166.1499999999999 C 1105.79 1121.6799999999998 1119.04 1073.3999999999999 1124.13 1022.7799999999999 L 699.6200000000001 1113.0199999999998 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -47.37)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-562.06, -580.83)",
    d: "M 1085.73 895.8 C 1105.79 851.3299999999999 1119.05 803.05 1124.13 752.43 L 793.45 822.76 L 793.45 687.56 L 1085.72 625.4499999999999 C 1105.78 580.9799999999999 1119.04 532.6999999999999 1124.1200000000001 482.0799999999999 L 793.44 552.3499999999999 L 793.44 66.13 C 742.7700000000001 94.58 697.7700000000001 132.45 661.19 177.12 L 661.19 580.47 L 528.94 608.58 L 528.94 0 C 478.27000000000004 28.44 433.27000000000004 66.32 396.69000000000005 110.99 L 396.69000000000005 636.6800000000001 L 100.78000000000003 699.5600000000001 C 80.72000000000003 744.0300000000001 67.45000000000003 792.3100000000001 62.36000000000003 842.9300000000001 L 396.69 771.8800000000001 L 396.69 942.1400000000001 L 38.389999999999986 1018.2800000000001 C 18.329999999999988 1062.75 5.069999999999986 1111.0300000000002 -0.010000000000012221 1161.65 L 375.03000000000003 1081.95 C 405.56000000000006 1075.6000000000001 431.8 1057.55 448.86 1032.71 L 517.64 930.74 L 517.64 930.72 C 524.78 920.1700000000001 528.9399999999999 907.45 528.9399999999999 893.75 L 528.9399999999999 743.77 L 661.1899999999999 715.66 L 661.1899999999999 986.06 L 1085.7199999999998 895.78 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSarForDarkTheme);
export default __webpack_public_path__ + "static/media/sar_for_dark_theme.f12b193d2a42a2cffdcb43dc1cac1e1b.svg";
export { ForwardRef as ReactComponent };